module.exports = __webpack_public_path__ + "static/media/mobile-gestures.0b0facef.svg";